module.exports = __webpack_public_path__ + "img/V12-bg.1c737206.png";